export const FIRST_POST_PROMPTS = [
  { key: 'mainGoal', emoji: '🎯' },
  { key: 'whyJoined', emoji: '👋' },
  { key: 'recentWin', emoji: '🌟' },
  { key: 'currentChallenge', emoji: '🧗' },
  { key: 'supportNeeded', emoji: '🤝' },
  { key: 'habitStarting', emoji: '🌱' },
] as const;

export type FirstPostPromptKey = (typeof FIRST_POST_PROMPTS)[number]['key'];

export const FIRST_POST_MIN_LENGTH = 20;

export const isMeaningfulFirstPost = (
  content: string,
  hasMedia: boolean,
): boolean => {
  const trimmedContent = content.trim();
  return (
    trimmedContent.length >= FIRST_POST_MIN_LENGTH
    || (hasMedia && trimmedContent.length > 0)
  );
};
